import React from 'react'
import { useIsMobile } from '@amzn/storm-ui'
import { DesktopLaunchModal } from './DesktopLaunchModal'
import { MobileLaunchModal } from './MobileLaunchModal'
import { ImageProp, LinkProp } from '../../common/props'

export type LaunchModalMediaSize = 'medium' | 'large'

export interface CarouselSlideShapeProps {
  headline: string
  caption?: string
  duration?: number
  image: ImageProp
  link?: LinkProp
}

export interface LaunchModalProps {
  isMobile?: boolean
  message: string
  anchorId: string
  logo?: ImageProp
  closeButtonText?: string
  nextButtonText?: string
  previousButtonText?: string
  playButtonText?: string
  pauseButtonText?: string
  slides: CarouselSlideShapeProps[]
  slidesDuration?: number
  imageSize?: LaunchModalMediaSize
  dataTaktId: string
}

export const LaunchModal: React.VFC<LaunchModalProps> = (props) => {
  const mobileFromTheme = useIsMobile()
  if (props.isMobile || mobileFromTheme) return <MobileLaunchModal {...props} />
  else return <DesktopLaunchModal {...props} />
}
